module.exports = __webpack_public_path__ + "media/images/vyskovmapa26.11mobile-dd3053b9.svg";